import { createAsyncThunk } from '@reduxjs/toolkit'
import apiRequest from '../../lib/http'
import { normalizeError } from '../../utils/errorHelpers'

export const getPortalCreditScores = createAsyncThunk(
  'creditScores/getPortal',
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiRequest.get('/portal/credit-scores')
      return response.data.data
    } catch (error) {
      return rejectWithValue(normalizeError(error))
    }
  }
)

export const getContactCreditScores = createAsyncThunk(
  'creditScores/getContact',
  async (userId, { rejectWithValue }) => {
    try {
      const response = await apiRequest.get(`/credit-reports/users/${userId}/scores`)
      return response.data.data
    } catch (error) {
      return rejectWithValue(normalizeError(error))
    }
  }
)

export const setPortalCreditScoresShown = createAsyncThunk(
  'creditScores/setShown',
  async ({ userId, shown }, { rejectWithValue }) => {
    try {
      const response = await apiRequest.patch(`/customUsers/${userId}/portal-credit-scores`, { shown })
      return response.data.data
    } catch (error) {
      return rejectWithValue(normalizeError(error))
    }
  }
)
